import { Flex, Skeleton } from '@chakra-ui/react';
import React from 'react';

// import { BalanceSheetExposure } from './BalanceSheetExposure';
import { FacilitiesOverviewTiles } from './FacilitiesOverviewTiles';
import { FacilitiesTable } from './FacilitiesTable';
import { useFacilitiesTableData } from './useFacilitiesTableData';
import { RouteErrorBoundary } from '~/contexts/MonitoringProvider';
import { useUserAuthOrThrow } from '~/contexts/UserAuthProvider';
import { DefaultErrorRoute } from '~/core/DefaultErrorRoute';

// Fragments
const RouteBase = () => {
  const { user } = useUserAuthOrThrow();
  const {
    error,
    loading,
    computedRows,
    creditFacilities,
    totalsRow,
  } = useFacilitiesTableData();

  if (error) throw error;
  if (loading) return <Skeleton height="600px" />;

  return (
    <Flex flexDirection="column" gap="4rem">
      <FacilitiesOverviewTiles
        creditFacilityCount={creditFacilities.length}
        totalsRow={totalsRow}
      />
      {/* <BalanceSheetExposure /> */}
      <FacilitiesTable
        creditFacilities={creditFacilities}
        enableFacilitySelection={user.userType !== 'BORROWER'}
        rows={computedRows}
        totalsRow={totalsRow}
      />
    </Flex>
  );
};

// Exports
export const Route = () => {
  return (
    <RouteErrorBoundary
      // This is the "home" route for borrowers and cap providers, so we have no where to redirect
      // to on error and render a default error route instead
      resetAfterCatch={false}
      fallback={({ message, showErrorToast }) => {
        showErrorToast(message);
        return <DefaultErrorRoute />;
      }}
    >
      <RouteBase />
    </RouteErrorBoundary>
  );
};
